module.exports = __webpack_public_path__ + "static/media/sending-order.23d69032.jpg";